import useLocale from '@/client/hooks/use-locale';
import { formatDate } from '@/client/utils/format';
import type { Time } from 'lightweight-charts';

type FormatDateProps = {
  time: Time | Date;
  formatStr?: string;
  /** IANA zone. Only set it when the surrounding UI labels the zone (see formatDate). */
  timeZone?: string;
};
export const FormatDate = ({ time, formatStr, timeZone }: FormatDateProps) => {
  const { locale } = useLocale();
  return formatDate(time, locale, formatStr, timeZone);
};
